// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */
// @ts-nocheck
import type * as Types from '@/graphql/schema';

import fetchClient from '@/graphql/fetchMutation';
import fetchServer from '@/graphql/fetchQuery';
import gql from '@/graphql/gql';
import { ScoreFragmentDoc } from '../../../../../shared/graphql/ScoreFragment.generated';
export type TournamentClaimPrizeMutationVariables = Types.Exact<{
  scoreId: Types.Scalars['String']['input'];
}>;


export type TournamentClaimPrizeMutation = { __typename?: 'Mutation', casinoTournamentsPublicClaimPrizeMutation?: { __typename?: 'CasinoTournamentsPublicClaimPrizeMutationPayload', success?: boolean, errors?: Array<{ __typename?: 'CasinoTournamentsPublicError', message?: string }>, score?: { __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean } } };


export const TournamentClaimPrizeMutationDocument = gql`
    mutation TournamentClaimPrizeMutation($scoreId: String!) {
  casinoTournamentsPublicClaimPrizeMutation(input: {scoreId: $scoreId}) {
    success
    errors {
      message
    }
    score {
      ...ScoreFragment
    }
  }
}
    ${ScoreFragmentDoc}`;

export const getTournamentClaimPrizeMutation = async (variables: TournamentClaimPrizeMutationVariables) => {
  return fetchClient<TournamentClaimPrizeMutation, TournamentClaimPrizeMutationVariables>(TournamentClaimPrizeMutationDocument, "TournamentClaimPrizeMutation", { variables });
}
export const getTournamentClaimPrizeAction = async (variables: TournamentClaimPrizeMutationVariables) => {
  return fetchServer<TournamentClaimPrizeMutation, TournamentClaimPrizeMutationVariables>(TournamentClaimPrizeMutationDocument, "TournamentClaimPrizeMutation", { variables });
}